export default __webpack_public_path__ + "/dist/images/b2b.svg";